import axios from 'axios';
import {
  INTEGRATION_STATUS, CONNECTION_STATUS_TD,
  KEY_TD_CONNECTION_STATUS, KEY_TD_INTEGRATION_STATUS,
  TD_TYPE_TAKE_LIMIT,
} from '../components/actions/constants';

const initialState = {
  transactionData: {},
  integrationStatus: INTEGRATION_STATUS.DISCONNECTED,
  transactionTypes: [],
  contactTypes: [],
  hasFinishedLoadingContactTypes: false,
  hasFinishedLoadingTransactionTypes: false,
  oauthUrl: '',
  message: '',
  hasError: false,
  errorMsgKey: 1,
  isLoading: false,
  connectionStatus: CONNECTION_STATUS_TD.PENDING,
  status: [
    { key: CONNECTION_STATUS_TD.PENDING, style: 'pending-status', title: 'Loading Authorization...' },
    { key: CONNECTION_STATUS_TD.SUCCESS, style: 'success-status', title: 'Succesfully connected to TransactionDesk' },
    { key: CONNECTION_STATUS_TD.ERROR, style: 'error-status', title: 'Unable to connect to TransactionDesk' },
  ],
};

export default {
  namespaced: true,
  state: { ...initialState },
  getters: {
    getStyleStatus: state => status => {
      return state.status.filter(p => p.key === status)[0].style;
    },
    getTitleStatus: state => status => {
      return state.status.filter(p => p.key === status)[0].title;
    },
  },
  mutations: {
    setIntegrationStatus(state, status) {
      state.integrationStatus = status;
    },
    setConnectionStatus(state, status) {
      state.connectionStatus = status;
    },
    setTransactionTypes(state, data) {
      state.transactionTypes = [...state.transactionTypes, ...data];
    },
    setContactTypes(state, data) {
      state.contactTypes = [...state.contactTypes, ...data];
    },
    setHasFinishedLoadingContactTypes(state, boolean) {
      state.hasFinishedLoadingContactTypes = boolean;
    },
    setHasFinishedLoadingTransactionTypes(state, boolean) {
      state.hasFinishedLoadingTransactionTypes = boolean;
    },
    resetConnectionStatus(state) {
      setTimeout(() => {
        state.connectionStatus = CONNECTION_STATUS_TD.PENDING;
        localStorage.removeItem(KEY_TD_CONNECTION_STATUS);
      }, 1200);
    },
    setErrorMessage(state, message) {
      state.message = message;
      state.hasError = true;
      state.errorMsgKey = Math.floor((Math.random() * 1000) + 1);
    },
    clearErrorMessage(state) {
      state.message = '';
      state.hasError = false;
      state.errorMsgKey = 1;
    },
    setIsLoading(state, boolean) {
      state.isLoading = boolean;
    },
    setUrlOauth(state, url) {
      state.oauthUrl = url;
    },
    setTransactionDeskData(state, data) {
      state.transactionData = data;
    },
  },

  actions: {
    async getIntegrationStatus({ commit, rootState, dispatch }, forceUpdate = false) {
      try {
        if (!rootState.integrations.loaded || forceUpdate) {
          await dispatch('integrations/getIntegrations', null, { root: true });
        }
        let integrations = rootState.integrations.integrations;
        const integration = integrations.find(n => n.name === 'TransactionDesk');
        if (integration) {
          return commit('setIntegrationStatus', integration.status);
        }
      } catch (error) {
        commit('setIntegrationStatus', error);
      }
    },

    async saveTokenTransactiondesk({ commit }, { code }) {
      const req = {
        code,
      };
      try {
        commit('clearErrorMessage');
        await axios.post(`${process.env.VUE_APP_INTEGRATIONS}/transactiondesk/auth`, req);
        commit('setIntegrationStatus', 'connected');
        commit('setConnectionStatus', CONNECTION_STATUS_TD.SUCCESS);
        localStorage.setItem(KEY_TD_CONNECTION_STATUS, CONNECTION_STATUS_TD.SUCCESS);
        localStorage.setItem(KEY_TD_INTEGRATION_STATUS, INTEGRATION_STATUS.CONNECTED);
      } catch (error) {
        commit('setErrorMessage', error);
        commit('setConnectionStatus', CONNECTION_STATUS_TD.ERROR);
        localStorage.setItem(KEY_TD_CONNECTION_STATUS, CONNECTION_STATUS_TD.ERROR);
        localStorage.setItem(KEY_TD_INTEGRATION_STATUS, INTEGRATION_STATUS.DISCONNECTED);
      }
    },
    async createTransaction({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        commit('clearErrorMessage');
        const res = await axios.post(`${process.env.VUE_APP_INTEGRATIONS}/transactiondesk/transactions`, payload);
        commit('setTransactionDeskData', res.data);
      } catch (error) {
        commit('setErrorMessage', error.data.error);
      } finally {
        commit('setIsLoading', false);
      }
    },
    getUrlOauth({ commit }) {
      const redirectUrl = process.env.VUE_APP_TRANSACTIONDESK_REDIRECT_URI;
      const clientId = process.env.VUE_APP_TRANSACTIONDESK_CLIENT_ID;
      const oauthUrl = `${process.env.VUE_APP_TRANSACTIONDESK_API_URL}/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code&state=active`;
      commit('setUrlOauth', oauthUrl);
    },
    async fetchTransactionTypes({ commit }, skip) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_INTEGRATIONS}/transactiondesk/transaction-types?$skip=${skip}&$take=${TD_TYPE_TAKE_LIMIT}`)
        commit("setTransactionTypes", response.data);
        if (response.data.length < TD_TYPE_TAKE_LIMIT) {
          commit('setHasFinishedLoadingTransactionTypes', true);
        };
      } catch (error) {
        commit('setErrorMessage', error.data.error);
      }
    },
    async fetchContactTypes({ commit }, skip) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_INTEGRATIONS}/transactiondesk/contact-types?$skip=${skip}&$take=${TD_TYPE_TAKE_LIMIT}`)
        commit("setContactTypes", response.data);
        if (response.data.length < TD_TYPE_TAKE_LIMIT) {
          commit('setHasFinishedLoadingContactTypes', true);
        };
      } catch (error) {
        commit('setErrorMessage', error.data.error);
      }
    },
  },
};
